import { render } from "./ChatBotAiContextPropsCmp.vue?vue&type=template&id=1e820824"
import script from "./ChatBotAiContextPropsCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotAiContextPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__